const PROBE_BYTES = 8192

export const isFileReadable = async (file) => {
  if (!file || typeof file.slice !== 'function') return false
  const size = typeof file.size === 'number' ? file.size : 0
  try {
    await file.slice(0, Math.min(size || 1, PROBE_BYTES)).arrayBuffer()
    return size > 0
  } catch (e) {
    return false
  }
}

const PROBE_CONCURRENCY = 48

export const partitionUploadableFiles = async (items, getFile = (item) => item) => {
  const readable = []
  const unreadable = []
  for (let i = 0; i < items.length; i += PROBE_CONCURRENCY) {
    const batch = items.slice(i, i + PROBE_CONCURRENCY)
    const checks = await Promise.all(
      batch.map(async (item) => ({ item, ok: await isFileReadable(getFile(item)) }))
    )
    checks.forEach(({ item, ok }) => (ok ? readable : unreadable).push(item))
  }
  return { readable, unreadable }
}

export const cloudFileName = (item, getFile = (item) => item) => {
  const file = getFile(item)
  return item?.name || item?.path || file?.name || 'Unnamed file'
}
